import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import {
  AvForm,
  AvField,
  AvInput,
  AvRadio,
  AvRadioGroup,
  AvCheckbox,
  AvCheckboxGroup,
} from "availity-reactstrap-validation"
import SweetAlert from "react-bootstrap-sweetalert"
import moment from "moment"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import bgImage from "assets/images/ugifts/loginbg.png"
import bgProfile from "assets/images/ugifts/profile_bg.png"
import iconChooseProfile from "assets/images/ugifts/icons/icon_chooseprofile.png"

import { Button } from "@material-ui/core"
import { urlEncode } from "@sentry/utils"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const EditProfile = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      getUserProfile()
      getCountry()
      console.log("use effect")
    }
  }, [token])

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [countryData, setCountryData] = useState(null)
  const getCountry = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_country")
    urlencoded.append("order_by", "desc")

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setCountryData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [form, setState] = useState({})

  const updateResponseData = () => {
    setState({
      ...form,
      full_name: userData.name,
      email: userData.email,
      gender: userData.gender,
      dobText: userData.dob == "0000-00-00" ? "" : userData.dob,
      dob: new Date(userData.dob).getTime() / 1000,
      phone_number: userData.phone_number,
      phone_prefix: userData.phone_prefix,
      // country_id: userData.country,
      country: userData.country,
      billing_address: userData.billing_address,
      billing_postcode: userData.billing_postcode,
      billing_state: userData.billing_state,
      // billing_country: userData.billing_country,
      billing_country_id: userData.billing_country_id,
      shipping_address: userData.shipping_address,
      shipping_postcode: userData.shipping_postcode,
      shipping_state: userData.shipping_state,
      // shipping_country: userData.shipping_country,
      shipping_country_id: userData.shipping_country_id,
    })
  }

  useEffect(() => {
    if (userData) {
      updateResponseData()
    }
  }, [userData])

  const [selectedFile, setSelectedFile] = useState()
  const [isFilePicked, setIsFilePicked] = useState(false)
  const changeHandler = e => {
    console.log("change handler", e.target.files[0])
    setSelectedFile(e.target.files[0])
    setIsFilePicked(true)

    var reader = new FileReader()
    reader.onload = function (e) {
      document.getElementById("imgPreview").src = e.target.result
    }
    reader.readAsDataURL(e.target.files[0])
  }

  const updateField = e => {
    var field_name = e.target.name
    var field_value = e.target.value
    if (field_name == "dobText") {
      console.log("e.target.value", e.target.value)
      field_name = "dob"
      field_value = new Date(e.target.value).getTime() / 1000
    }
    setState({
      ...form,
      [field_name]: field_value,
    })
  }

  function setShippingAsBilling(e) {
    console.log(e.target.checked)

    if (e.target.checked) {
      setState({
        ...form,
        shipping_address: form.billing_address,
        shipping_postcode: form.billing_postcode,
        shipping_state: form.billing_state,
        shipping_country_id: form.billing_country_id,
      })
    }
  }

  const submitForm = async () => {
    console.log("form", form)

    var urlencoded = new FormData()
    // var urlencoded = new URLSearchParams()
    urlencoded.append("option", "update_profile")
    urlencoded.append("member_id", uid)
    for (var key in form) {
      switch (key) {
        case "billing_country_id":
        case "shipping_country_id":
          if (form[key] != "0" && form[key] != null)
            urlencoded.append(key, form[key])
          break
        case "dobText":
          if (form[key] != "0000-00-00" && form[key] != null)
            urlencoded.append(key, form[key])
          break
        case "dob":
          if (form[key] != NaN && form[key] != null)
            urlencoded.append(key, form[key])
          break
        default:
          if (form[key] != "" && form[key] != null)
            urlencoded.append(key, form[key])
      }
      // console.log(key, form[key])
    }
    // console.log(
    //   "billing country",
    //   countryData.filter(data => {
    //     return data.id == form.billing_country_id
    //   })[0]
    //     ? countryData.filter(data => {
    //         return data.id == form.billing_country_id
    //       })[0].name
    //     : ""
    // )
    if (form.billing_country_id != "0")
      urlencoded.append(
        "billing_country",
        countryData.filter(data => {
          return data.id == form.billing_country_id
        })[0]
          ? countryData.filter(data => {
              return data.id == form.billing_country_id
            })[0].name
          : ""
      )
    // console.log(
    //   "shipping country",
    //   countryData.filter(data => {
    //     return data.id == form.shipping_country_id
    //   })[0]
    //     ? countryData.filter(data => {
    //         return data.id == form.shipping_country_id
    //       })[0].name
    //     : ""
    // )
    if (form.shipping_country_id != "0")
      urlencoded.append(
        "shipping_country",
        countryData.filter(data => {
          return data.id == form.shipping_country_id
        })[0]
          ? countryData.filter(data => {
              return data.id == form.shipping_country_id
            })[0].name
          : ""
      )

    if (isFilePicked) urlencoded.append("profile_picture", selectedFile)

    // var urlencoded = new URLSearchParams()
    // urlencoded.append("option", "list_country")
    // urlencoded.append("order_by", "desc")

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Update profile", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )

    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setCountryData(postresponse.table)
      getUserProfile()
      if (postresponse.success) {
        setsuccess_dlg(true)
        setdynamic_title(props.t("Profile updated"))
        setdynamic_description(postresponse.message)
        // history.push("/profile")
      } else {
        seterror_alert(true)
        setdynamic_title(props.t("Update failed"))
        setdynamic_description(postresponse.message)
      }
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Update failed"))
      setdynamic_description(postresponse.message)
    }
  }

  function handleClick(e) {
    document.getElementById("inputProfilePhoto").click()
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                confirmBtnText={"Done"}
                onConfirm={() => {
                  history.push("/profile")
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  backgroundColor: "#F5F5F5",
                  paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {props.t("Edit Profile")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col onClick={handleClick}>
                        {userData &&
                          (!userData.profile_picture ? (
                            selectedFile ? (
                              <div className="avatar-lg mx-auto">
                                <img
                                  className="rounded-circle avatar-lg"
                                  id="imgPreview"
                                  // src={selectedFileSrc}
                                  alt=""
                                />
                                <img
                                  className="rounded-circle avatar-xs"
                                  src={iconChooseProfile}
                                  alt=""
                                  style={{
                                    position: "absolute",
                                    bottom: 0,
                                    right: "40%",
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="avatar-lg mx-auto">
                                <span
                                  className={
                                    "avatar-title rounded-circle bg-primary text-white font-size-24"
                                  }
                                >
                                  {userData.name
                                    ? userData.name.charAt(0)
                                    : userData.phone_number.charAt(0)}
                                </span>
                                <img
                                  className="rounded-circle avatar-xs"
                                  src={iconChooseProfile}
                                  alt=""
                                  style={{
                                    position: "absolute",
                                    bottom: 0,
                                    right: "40%",
                                  }}
                                />
                              </div>
                            )
                          ) : selectedFile ? (
                            <div className="avatar-lg mx-auto">
                              <img
                                className="rounded-circle avatar-lg"
                                id="imgPreview"
                                // src={selectedFileSrc}
                                alt=""
                              />
                              <img
                                className="rounded-circle avatar-xs"
                                src={iconChooseProfile}
                                alt=""
                                style={{
                                  position: "absolute",
                                  bottom: 0,
                                  right: "40%",
                                }}
                              />
                            </div>
                          ) : (
                            <div className="avatar-lg mx-auto">
                              <img
                                className="rounded-circle avatar-lg"
                                src={userData.profile_picture}
                                alt=""
                              />
                              <img
                                className="rounded-circle avatar-xs"
                                src={iconChooseProfile}
                                alt=""
                                style={{
                                  position: "absolute",
                                  bottom: 0,
                                  right: "40%",
                                }}
                              />
                            </div>
                          ))}
                        {/* {userData &&
                          (userData.profile_picture ? (
                            <div className="avatar-lg mx-auto">
                              <img
                                src={userData.profile_picture}
                                className="rounded-circle avatar-lg"
                                alt=""
                              />
                            </div>
                          ) : (
                            <div className="avatar-lg mx-auto">
                              <span
                                className={
                                  "avatar-title rounded-circle bg-primary text-white font-size-24"
                                }
                              >
                                {userData.name
                                  ? userData.name.charAt(0)
                                  : userData.phone_number.charAt(0)}
                              </span>
                            </div>
                          ))} */}
                        <Input
                          type="file"
                          className="form-control"
                          id="inputProfilePhoto"
                          accept="image/*"
                          // aria-describedby="inputGroupFileAddon04"
                          // aria-label="Upload"
                          onChange={changeHandler}
                          hidden
                        />
                      </Col>
                    </Row>
                    {userData && (
                      <AvForm>
                        <Row className="mt-3 px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("Full Name")}
                          </Label>
                          <Col className="">
                            <AvField
                              className="mb-3 font-size-15"
                              // label={"Full Name"}
                              placeholder={props.t("Enter Full Name")}
                              type="text"
                              value={form.full_name}
                              name="full_name"
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                // border: "none",
                                height: "50px",
                              }}
                              // errorMessage={"Please enter your full name"}
                              // validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("Gender")}
                          </Label>
                          <Col className="align-self-center">
                            <AvRadioGroup
                              inline
                              name="gender"
                              className="mb-3 align-self-center"
                              value={form.gender}
                              // label={props.t("Applicant Type")}
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                // border: "none",
                                height: "50px",
                                backgroundColor: "white",
                                border: "1px solid #ced4da",
                              }}
                              // required
                            >
                              <Row
                                className="px-3 my-2"
                                style={{ height: "32px" }}
                              >
                                <Col className="align-self-center font-size-15">
                                  <AvRadio
                                    label={props.t("Male")}
                                    value="Male"
                                    style={{ fontWeight: 400 }}
                                  />
                                </Col>
                                <Col className="align-self-center font-size-15">
                                  <AvRadio
                                    label={props.t("Female")}
                                    value="Female"
                                    style={{ fontWeight: 400 }}
                                  />
                                </Col>
                              </Row>
                            </AvRadioGroup>
                          </Col>
                        </Row>
                        <Row className="px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("Email")}
                          </Label>
                          <Col className="">
                            <AvField
                              className="mb-3 font-size-15"
                              // label={"Email"}
                              placeholder={props.t("Enter Email")}
                              type="text"
                              value={form.email}
                              name="email"
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                // border: "none",
                                height: "50px",
                              }}
                              // errorMessage={"Please enter your full email"}
                              // validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3 px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("Mobile")}
                          </Label>
                          <Col xs="auto" className="pe-1">
                            <select
                              className="form-control font-size-15"
                              style={{
                                borderRadius: "8px",
                                border: "none",
                                height: "50px",
                              }}
                              // name="phone_prefix"
                              // onChange={updateField}
                              disabled
                            >
                              {countryData &&
                                countryData.map((data, index) => (
                                  <option
                                    value={data.country_code}
                                    selected={
                                      data.country_code == form.phone_prefix
                                    }
                                  >
                                    {data.country_code}
                                  </option>
                                ))}
                              {/* <option
                                value="+60"
                                selected={userData.phone_prefix == "+60"}
                              >
                                +60
                              </option>
                              <option
                                value="+65"
                                selected={userData.phone_prefix == "+65"}
                              >
                                +65
                              </option> */}
                            </select>
                          </Col>
                          <Col className="ps-1">
                            <Input
                              type="text"
                              className="form-control font-size-15"
                              id="userMobile"
                              // name="phone_number"
                              // onChange={updateField}
                              placeholder={props.t("Enter mobile number")}
                              value={form.phone_number}
                              style={{
                                borderRadius: "8px",
                                border: "none",
                                height: "50px",
                              }}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className="px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("Date of Birth")}
                          </Label>
                          <Col className="">
                            <AvField
                              name="dobText"
                              // label="Start date"
                              type="date"
                              className="mb-3 font-size-15"
                              value={form.dobText}
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                height: "50px",
                              }}
                            />
                            {/* <input
                              name="dobText"
                              className="mb-3 font-size-15"
                              type="date"
                              // defaultValue="2019-08-19"
                              value={form.dobText}
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                height: "50px",
                              }}
                            /> */}
                          </Col>
                        </Row>
                        <Row className="px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("Registered Country")}
                          </Label>
                          <Col className="">
                            {form.country ? (
                              <AvField
                                className="mb-3 font-size-15"
                                // label={"Full Name"}
                                // placeholder={"Enter Full Name"}
                                type="text"
                                value={form.country}
                                name="country"
                                // onChange={updateField}
                                style={{
                                  borderRadius: "8px",
                                  // border: "none",
                                  height: "50px",
                                }}
                                disabled
                                // errorMessage={"Please enter your full name"}
                                // validate={{ required: { value: true } }}
                              />
                            ) : (
                              <AvField
                                className="mb-3 form-select font-size-15"
                                type="select"
                                // label={props.t("Participant")}
                                // helpMessage={props.t("Gender Placeholder")}
                                value={form.country_id}
                                name="country_id"
                                onChange={updateField}
                                // errorMessage={props.t("Field required")}
                                // validate={{ required: { value: true } }}
                                style={{
                                  borderRadius: "8px",
                                  height: "50px",
                                }}
                              >
                                {countryData &&
                                  countryData.map((data, index) => (
                                    <option value={data.id}>{data.name}</option>
                                  ))}
                              </AvField>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-2 px-3">
                          <Label className="font-size-18 font-weight-bold text-black">
                            {props.t("Billing Address")}
                          </Label>
                          <Col className="">
                            <AvField
                              className="mb-3 font-size-15"
                              // label={"Email"}
                              placeholder={"Enter Billing Address"}
                              type="textarea"
                              value={form.billing_address}
                              name="billing_address"
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                // border: "none",
                                // height: "50px",
                              }}
                              // errorMessage={"Please enter your full email"}
                              // validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("Postal Code")}
                          </Label>
                          <Col className="">
                            <AvField
                              className="mb-3 font-size-15"
                              // label={"Full Name"}
                              placeholder={props.t("Enter Postcode")}
                              type="text"
                              value={form.billing_postcode}
                              name="billing_postcode"
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                // border: "none",
                                height: "50px",
                              }}
                              // errorMessage={"Please enter your full name"}
                              // validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("State/Area")}
                          </Label>
                          <Col className="">
                            <AvField
                              className="mb-3 font-size-15"
                              // label={"Full Name"}
                              placeholder={props.t("Enter State/Area")}
                              type="text"
                              value={form.billing_state}
                              name="billing_state"
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                // border: "none",
                                height: "50px",
                              }}
                              // errorMessage={"Please enter your full name"}
                              // validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("Country")}
                          </Label>
                          <Col className="">
                            <AvField
                              className="mb-3 form-select font-size-15"
                              type="select"
                              // label={props.t("Participant")}
                              // helpMessage={props.t("Gender Placeholder")}
                              value={form.billing_country_id}
                              name="billing_country_id"
                              onChange={updateField}
                              // errorMessage={props.t("Field required")}
                              // validate={{ required: { value: true } }}
                              style={{
                                borderRadius: "8px",
                                height: "50px",
                              }}
                            >
                              {countryData &&
                                countryData.map((data, index) => (
                                  <option value={data.id}>{data.name}</option>
                                ))}
                            </AvField>
                          </Col>
                        </Row>
                        <Row className="mt-2 px-3">
                          <Row>
                            <Col>
                              <Label className="font-size-18 font-weight-bold text-black">
                                {props.t("Shipping Address")}
                              </Label>
                            </Col>
                            <Col className="align-self-center">
                              <input
                                type="checkbox"
                                className="form-check-input me-2"
                                id="customCheckcolor1"
                                // checked={customchkPrimary}
                                onChange={setShippingAsBilling}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="customCheckcolor1"
                              >
                                {props.t("Same as billing address")}
                              </label>
                            </Col>
                          </Row>

                          <Col className="">
                            <AvField
                              className="mb-3 font-size-15"
                              // label={"Email"}
                              placeholder={props.t("Enter Shipping Address")}
                              type="textarea"
                              value={form.shipping_address}
                              name="shipping_address"
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                // border: "none",
                                // height: "50px",
                              }}
                              // errorMessage={"Please enter your full email"}
                              // validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("Postal Code")}
                          </Label>
                          <Col className="">
                            <AvField
                              className="mb-3 font-size-15"
                              // label={"Full Name"}
                              placeholder={props.t("Enter Postal Code")}
                              type="text"
                              value={form.shipping_postcode}
                              name="shipping_postcode"
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                // border: "none",
                                height: "50px",
                              }}
                              // errorMessage={"Please enter your full name"}
                              // validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("State/Area")}
                          </Label>
                          <Col className="">
                            <AvField
                              className="mb-3 font-size-15"
                              // label={"Full Name"}
                              placeholder={props.t("Enter State/Area")}
                              type="text"
                              value={form.shipping_state}
                              name="shipping_state"
                              onChange={updateField}
                              style={{
                                borderRadius: "8px",
                                // border: "none",
                                height: "50px",
                              }}
                              // errorMessage={"Please enter your full name"}
                              // validate={{ required: { value: true } }}
                            />
                          </Col>
                        </Row>
                        <Row className="px-3">
                          <Label className="font-size-15 font-weight-bold text-secondary">
                            {props.t("Country")}
                          </Label>
                          <Col className="">
                            <AvField
                              className="mb-3 form-select font-size-15"
                              type="select"
                              // label={props.t("Participant")}
                              // helpMessage={props.t("Gender Placeholder")}
                              value={form.shipping_country_id}
                              name="shipping_country_id"
                              onChange={updateField}
                              // errorMessage={props.t("Field required")}
                              // validate={{ required: { value: true } }}
                              style={{
                                borderRadius: "8px",
                                height: "50px",
                              }}
                            >
                              {countryData &&
                                countryData.map((data, index) => (
                                  <option value={data.id}>{data.name}</option>
                                ))}
                            </AvField>
                          </Col>
                        </Row>
                        <Row
                          className="m-0 w-100"
                          style={{
                            height: "76px",
                            backgroundColor: "#ffffff",
                            position: "fixed",
                            bottom: 0,
                            zIndex: 1030,
                            maxWidth: "480px",
                            boxShadow:
                              "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                          }}
                        >
                          <Col className="h-100 p-0">
                            <Card body className="mb-0 p-3">
                              <button
                                // to="#"
                                className="btn btn-danger waves-effect waves-light font-size-18"
                                style={{
                                  borderRadius: "8px",
                                  // height: "50px",
                                }}
                                onClick={submitForm}
                              >
                                {props.t("Save")}
                              </button>
                            </Card>
                          </Col>
                        </Row>
                      </AvForm>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(EditProfile)

EditProfile.propTypes = {
  t: PropTypes.any,
}
